import { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

import { MemberType } from '../../../../api/ceremony';
import { getCookie, setCookie } from '../../../../helpers/helper';
import { useChecklist } from '../../../../provider/checklistProvider';
import { useDashboard } from '../../../../provider/dashboardProvider';
import Button from '../../Button/Button';
import CampaignItem from '../../CampaignItem/CampaignItem';
import { Modal } from '../../Modal/Modal';
import { Typography } from '../../Typography/Typography';




const CoupleChecklistPopup = () => {
    const { orders, ordersFetched, ceremony, currentUser } = useDashboard();
    const { completedChecklistItemsCount } = useChecklist();
    const navigate = useNavigate();
    const url = useLocation();

    const [isOpen, setIsOpen] = useState(false);

    const coupleChecklistPopupCookie = getCookie('couple-checklist-popup-cooldown');

    useEffect(() => {
        const urlIsChecklist = url.pathname.includes('/checklist');
        const confirmedOrders = orders.filter(order => order.status === 'confirmed' && order.ceremony_id === ceremony?.id);
        const isOneHourPassed = coupleChecklistPopupCookie
            ? new Date(coupleChecklistPopupCookie).getTime() + 1000 * 60 * 60 < Date.now()
            : true;

        if (
            urlIsChecklist &&
            ordersFetched &&
            confirmedOrders.length === 0 &&
            completedChecklistItemsCount >= 2 &&
            isOneHourPassed &&
            currentUser?.member_type &&
            [MemberType.bride, MemberType.groom, MemberType.other].includes(currentUser?.member_type)
        ) {
            setIsOpen(true);
            setCookie('couple-checklist-popup-cooldown', new Date().toISOString(), 1);
        }

        if(confirmedOrders.length > 0) {
            setIsOpen(false);
        }

    }, [orders, completedChecklistItemsCount, ordersFetched, url, currentUser]);

    return (
        <Modal
            isOpen={isOpen}
            onClose={() => setIsOpen(false)}
            fullWidth={false}
            fillScreen={false}
            maxWidth='lg'
        >
            <div className='self-center max-w-md flex flex-col justify-center text-center'>
                <Typography type='display-100' className='mb-4'>
                Special Offer
                </Typography>
                <CampaignItem
                    hideIfPaid={false}
                    regularComponent={
                        <Typography type='body-400' className='mb-8'>
                            <> Gain access to all the tools you need to successfully write your vows, ceremony, toasts and more with an extra 10% off if you purchase right now with code <u>GETSTARTED10</u></>
                        </Typography>
                    }
                    renderCampaignComponent={(discountPercentage, couponCode) => (
                        <Typography type='body-400' className='mb-8'>
                            <> {`Gain access to all the tools you need to successfully write your vows, ceremony, toasts and more with an extra ${discountPercentage}% off if you purchase right now with code `}
                                <u>{couponCode}</u>.</>
                        </Typography>
                    )}
                />
                <div className='flex flex-col-reverse md:flex-row justify-between'>
                    <Button
                        className='mt-2 md:mt-0 md:mr-2 md:w-auto w-full'
                        onClick={() => setIsOpen(false)}
                        variant='text'
                    >
                        Keep Exploring
                    </Button>
                    <Button
                        className='md:w-auto w-full'
                        onClick={() => {
                            setIsOpen(false)
                            navigate(`/pay-plans/${ceremony?.id || ''}`)
                        }}
                    >
                        Get Started
                    </Button>
                </div>
            </div>
        </Modal>
    );
};

export default CoupleChecklistPopup;
